import { useState } from "react";

import { ExternalLink, Link } from "lucide-react";

import { SimpleTooltip } from "@/components/ui/tooltip";

interface RubricLinkIndicatorProps {
  rubricName: string;
  rubricUuid: string;
  itemType?: "criterion" | "item";
}

export function RubricLinkIndicator({
  rubricName,
  rubricUuid,
  itemType = "criterion",
}: RubricLinkIndicatorProps) {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = (e: React.SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(`/rubrics/${rubricUuid}`, "_blank");
  };

  const tooltipContent = (
    <div className="space-y-1">
      <div className="text-xs opacity-80">
        {itemType === "criterion"
          ? "This criterion is synced from a rubric template"
          : "This item is synced from a rubric template"}
      </div>
      <div className="text-sm">{rubricName}</div>
    </div>
  );

  return (
    <SimpleTooltip content={tooltipContent}>
      <span
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`inline-flex h-6 w-6 cursor-pointer items-center justify-center rounded transition-all duration-200 ${
          isHovered
            ? "bg-blue-600 text-white"
            : "bg-gray-100 text-gray-600 hover:bg-gray-200"
        } `}
        aria-label={`Linked from rubric: ${rubricName}`}
        role="button"
        tabIndex={0}
        onKeyDown={(e: React.KeyboardEvent<HTMLSpanElement>) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleClick(e);
          }
        }}
      >
        {isHovered ? (
          <ExternalLink className="h-3.5 w-3.5" />
        ) : (
          <Link className="h-3.5 w-3.5" />
        )}
      </span>
    </SimpleTooltip>
  );
}
